

export const CardRadio = () => {

    return (
        <div className="form-check">
            <input className="form-check-input" type="radio" name="pay-methods" value='card' id="card"/>
            <label className="form-check-label fs-6 fw-bold" htmlFor="card">
                Карта - при отриманні замовлення
            </label>
        </div>
    )
}